<mat-tab-group>
  <mat-tab label="CADASTRO">
    <form *ngIf="userForm" [formGroup]="userForm" (submit)="doSaveUser()">
      <div class="input-container">
        <div class="row-1">
          <mat-form-field fxFlex>
            <mat-label>Perfis</mat-label>
            <mat-select #selectedUserRole required formControlName="userRole" (selectionChange)="onUserRoleChange()">
              <mat-option *ngFor="let userRole of userRoleList" [value]="userRole">{{ userRole.getName() }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex="45" *ngIf="canShowUserPermissions()">
            <mat-label>Permissões</mat-label>
            <mat-select formControlName="userPermissionList" multiple>
              <mat-option *ngFor="let userPermission of permissionList()" [value]="userPermission">{{ userPermission.getName() }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="fieldDirective.externalClientId.visible()" fxFlex>
            <mat-label>Client Id</mat-label>
            <input formControlName="externalClientId" matInput placeholder="Client Id" required />
          </mat-form-field>
        </div>
        <div class="row-2">
          <mat-form-field fxFlex="50">
            <mat-label>Nome</mat-label>
            <input formControlName="name" matInput placeholder="Nome" required />
          </mat-form-field>
          <mat-form-field fxFlex="50">
            <mat-label>E-mail</mat-label>
            <input formControlName="email" matInput placeholder="E-mail" required />
          </mat-form-field>
        </div>
        <div class="row-3">
          <mat-form-field fxFlex="33">
            <mat-label>CNPJ</mat-label>
            <input
              formControlName="fiscalNumber"
              matInput
              placeholder="CNPJ"
              required
              matTooltip="CNPJ da empresa que o usuário é registrado"
              [textMask]="{ mask: fiscalNumberMaskInput, guide: false }" />
          </mat-form-field>
          <mat-form-field fxFlex *ngIf="!isEditing && fieldDirective.password.visible()">
            <mat-label>Senha</mat-label>
            <input #password formControlName="password" matInput placeholder="Senha" required (focus)="setPasswordFocused(true)" />
            <input-message message="Senha inválida" color="red" *ngIf="passwordFocused && !isPasswordValid(password.value)"> </input-message>
            <mat-icon
              style="margin-left: 5px"
              matSuffix
              matTooltipClass="info-tooltip"
              matTooltip="A senha deve conter:
              - Mínimo 8 caracteres
              - Ao menos um caractere especial
              - Ao menos uma letra minúscula
              - Ao menos uma letra maiúscula
              - Ao menos um número"
              matTooltipPosition="above"
              >info</mat-icon
            >
          </mat-form-field>
          <mat-form-field fxFlex *ngIf="fieldDirective.telephone.visible()">
            <mat-label>Tipo do telefone</mat-label>
            <mat-select formControlName="telephoneType" #mask [value]="0">
              <mat-option [value]="0">Trabalho</mat-option>
              <mat-option [value]="1">Celular</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field fxFlex *ngIf="fieldDirective.telephone.visible()">
            <mat-label>Telefone</mat-label>
            <input
              #telephoneInput
              formControlName="telephone"
              matInput
              placeholder="Telefone"
              [textMask]="{
                mask: getTelephoneMask(userForm.get('telephone').value),
                guide: false,
                keepCharPositions: true
              }"
              required />
          </mat-form-field>
        </div>
        <div class="row-4" *ngIf="fieldDirective.isHealthProfessional.visible()">
          <mat-checkbox
            fxFlex="30"
            fxLayoutAlign="start center"
            class="isHealthProfessional"
            #isHealthProfessional
            formControlName="isHealthProfessional"
            labelPosition="before"
            >Profissional da saúde?</mat-checkbox
          >
          <div class="professional-fields" *ngIf="isHealthProfessional.checked" fxFlex="70">
            <mat-form-field fxFlex="50">
              <mat-label>Conselho de Classe</mat-label>
              <input formControlName="classCouncil" matInput placeholder="Conselho de Classe" required />
            </mat-form-field>
            <mat-form-field fxFlex="50">
              <mat-label>Número do Registro</mat-label>
              <input formControlName="registrationNumber" matInput placeholder="Número do Registro" required />
            </mat-form-field>
          </div>
        </div>
        <div class="row-5" *ngIf="isEditing && hasAccessToEditUser() && fieldDirective.password.visible()">
          <mat-checkbox
            fxFlex="20"
            fxLayoutAlign="start center"
            [style.pointer-events]="hasAccessToEditUser() ? '' : 'none'"
            formControlName="active"
            labelPosition="before"
            >Ativo</mat-checkbox
          >
          <div class="password-fields" fxFlex="80">
            <mat-form-field fxFlex="50" matTooltip="Mudar senha do usuário">
              <mat-label>Nova senha</mat-label>
              <input formControlName="newPassword" #newPassword matInput placeholder="Nova senha" required (focus)="setPasswordFocused(true)" />
              <input-message message="Senha inválida" color="red" [hidden]="!passwordFocused || isPasswordValid(newPassword.value)"> </input-message>
              <mat-icon
                style="margin-left: 5px"
                matSuffix
                matTooltipClass="info-tooltip"
                matTooltip="A senha deve conter:
                - Mínimo 8 caracteres
                - Ao menos um caractere especial
                - Ao menos uma letra minúscula
                - Ao menos uma letra maiúscula
                - Ao menos um número"
                matTooltipPosition="above"
                >info</mat-icon
              >
            </mat-form-field>
            <mat-form-field fxFlex="50">
              <mat-label>Confirmação da nova senha</mat-label>
              <input formControlName="confirmNewPassword" #confirmNewPassword matInput placeholder="Confirmação da nova senha" required />
              <input-message message="Senha diferente" color="red" [hidden]="comparePasswords(newPassword, confirmNewPassword)"> </input-message>
            </mat-form-field>
          </div>
        </div>

        <div class="select-cnpjs" [hidden]="!canAllowPermissionPerCompany()">
          <div class="label-cnpj" matTooltip="Selecione pelo menos 1 CNPJ">CNPJs Vinculados * [ {{ getSelectedDescription() }} ]</div>

          <div class="row-6">
            <div class="fields-search" fxFlex="85">
              <mat-form-field fxFlex="25" class="cnpj-field">
                <mat-label>CNPJ Matriz</mat-label>
                <input formControlName="filterText" matInput placeholder="CNPJ Matriz" [textMask]="{ mask: fiscalNumberMaskInput, guide: false }" />
              </mat-form-field>

              <mat-form-field fxFlex="20" class="company-field">
                <mat-label>Unidade</mat-label>
                <mat-select formControlName="companyType">
                  <mat-option [value]="2">Todas</mat-option>
                  <mat-option [value]="0">Matriz</mat-option>
                  <mat-option [value]="1">Filial</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field fxFlex="20" class="uf-field">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="region" (selectionChange)="onStateInputChange()">
                  <mat-option [value]="''">Todos</mat-option>
                  <mat-option *ngFor="let state of getStateList()" [value]="state.getValue()">{{ state.getValue() }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field fxFlex="25">
                <mat-label>Cidade</mat-label>
                <mat-select formControlName="city">
                  <mat-option [value]="''">Todas</mat-option>
                  <mat-option *ngFor="let city of getCityList()" [value]="city.getName()">{{ city.getName() }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <button type="button" fxFlex="15" class="filter-button" mat-flat-button color="primary" (click)="doSearchAllCompanies()">
              <mat-icon aria-hidden="false">filter_list</mat-icon>
              FILTRAR
            </button>
          </div>

          <div [hidden]="dataSource.data.length == 0">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" (matSortChange)="sortTable()">
              <!-- CNPJ Column -->
              <ng-container matColumnDef="fiscalNumber">
                <th mat-header-cell *matHeaderCellDef>CNPJ</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.getFiscalNumber() | companyFederalNumber }}
                </td>
              </ng-container>

              <!-- Unidade Column -->
              <ng-container matColumnDef="companyType">
                <th mat-header-cell *matHeaderCellDef>Unidade</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.getCompanyType() == 0 ? "Matriz" : "Filial" }}
                </td>
              </ng-container>

              <!-- Razão Social Column -->
              <ng-container matColumnDef="corporateName">
                <th mat-header-cell *matHeaderCellDef>Razão Social</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.getCorporateName() }}
                </td>
              </ng-container>

              <!-- UF Column -->
              <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef>UF</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.getCompanyInfo().getAddress().getRegion() }}
                </td>
              </ng-container>

              <!-- Cidade Column -->
              <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef>Cidade</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.getCompanyInfo().getAddress().getCity() }}
                </td>
              </ng-container>

              <!-- Checkbox Column -->
              <ng-container matColumnDef="check">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selectedCompanies.selected.length > 0 && isAllSelected()"
                    [indeterminate]="selectedCompanies.selected.length > 0 && !isAllSelected()">
                  </mat-checkbox>
                </th>

                <td mat-cell *matCellDef="let element">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="selectCompany(element)" [checked]="getIsSelected(element) != -1"> </mat-checkbox>
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td
                  [title]="getTableState(element) === 'Alterado' ? 'Este dado foi alterado agora.' : ''"
                  mat-cell
                  *matCellDef="let element"
                  [ngStyle]="getTableState(element) === 'Salvo' ? { color: '#14A85B' } : { color: '#F2950A' }">
                  <strong> {{ getTableState(element) }} </strong>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" (page)="pageChange()" showFirstLastButtons class="mat-elevation-z8"> </mat-paginator>
          </div>
        </div>

        <br />
        <div class="button-container">
          <button mat-flat-button color="primary">SALVAR USUÁRIO</button>
        </div>
        <br />
      </div>
    </form>
  </mat-tab>
</mat-tab-group>
